// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "notification".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "notification" table (1:1 with a DB row, on the wire). */
export const notificationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    type: z.string(),
    title: z.string(),
    body: z.string(),
    linkPath: z.string().nullable(),
    data: z.unknown().nullable(),
    readAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=notification.js.map